<template>
    <el-dialog
        title="添加课程"
        :visible.sync="visible"
        width="7.7rem"
        class="step-audit-dialog"
        key="coursedialog"
        :before-close="handleCourseDialogClose">
        <el-form :model="form" :inline="true" label-width="100px" key="3" class="user-step-search-form">
            <el-form-item label="课程名称：" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="课程目录：" prop="courseGroupId">
                <el-cascader
                    :options="form.options"
                    :props="{ checkStrictly: true, label: 'name', value: 'id', children: 'childrens' }"
                    v-model="form.courseGroupId"
                    clearable></el-cascader>
            </el-form-item>
            <el-form-item label="" class="search-itrm-btn">
                <el-button size="mini" @click="handleCourseDialogSearch">查询</el-button>
                <el-button size="mini" class="reset-btn" @click="handleCourseDialogReset">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="training-step-table">
            <el-table :data="tableForm.formResult.list" style="width: 100%" key="coursetable" @selection-change="handleCourseTableSeleChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="title" show-overflow-tooltip label="课程名称"></el-table-column>
                <el-table-column prop="courseGroupName" label="课程目录"></el-table-column>
                <el-table-column prop="releaseTime" label="发布时间" width="168"></el-table-column>
                <el-table-column prop="username" label="发布人账号" width="168"></el-table-column>
            </el-table>
            <pagination key="coursepage" @request-form-list="queryCourseList" :form="tableForm"></pagination>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleCourseDialogSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import pagination from '@/components/pagination/index'

export default {
    name: 'course-dialog',
    components: { pagination },
    props: ['visible'],
    data() {
        return {
            form: {title: '', courseGroupId:[], options: []},
            tableForm: {
                formResult: { currentPage: 1, list: [], total: 0 },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            },
            selectTable: []
        }
    },
    methods: {
        // 弹窗-课程保存
        handleCourseDialogSave() {
            this.$emit('confirmDailog', this.selectTable)
            this.handleCourseDialogClose()
        },
        // 弹窗-课程关闭
        handleCourseDialogClose() {
            this.$emit('closeDailog')
        },
        // 弹窗-课程搜索
        handleCourseDialogSearch() {
            this.tableForm.pageData.currentPage = 1
            this.queryCourseList()
        },
        // 弹窗-课程重置
        handleCourseDialogReset() {
            this.form.courseGroupId = []
            this.form.title = ''
            this.handleCourseDialogSearch()
        },
        // 弹窗-表格选择
        handleCourseTableSeleChange(data) {
            this.selectTable = data
        },
        // 加载课程
        queryCourseList() {
            this.$api.course.courseList({
                formData: { courseGroupId: this.form.courseGroupId.length > 0 ? this.form.courseGroupId[0] : '', title: this.form.title},
                pageData: this.tableForm.pageData
            }).then(res => {
                this.tableForm.formResult = res.data
            })
        },
        // 加载课程分类
        queryTreeList() {
            this.$api.course.treeList().then(res => {
                this.form.options = res.data
            })
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.selectTable = null
                this.queryTreeList()
                this.handleCourseDialogReset()
            }
        }
    }
}
</script>